
import Vue from 'vue';
export default Vue.extend({
  name: 'TextLink',
  props: {
    text: {
      type: String,
      required: true,
    },
  },
});
